<div class="notifications-container">
  <app-notification-panel-toggle
    [count]="notifications().length"
    [opened]="isPanelOpen()"
    (openedChange)="togglePanel($event)">
  </app-notification-panel-toggle>

  <app-notification-panel
    [itemsCount]="notifications().length"
    [visible]="isPanelOpen()"
    (clearAll)="onClearAllNotifications()">
    @for (notification of notifications(); track notification.id) {
      <ng-container [ngComponentOutlet]="notification.type" [ngComponentOutletInputs]="notification.inputs"></ng-container>
    }
  </app-notification-panel>
</div>
